import React, { useEffect, useState } from 'react'
import "../styles/navbar.scss"
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import logo from "../assets/icone/logo_vett_b.svg"

export default function Navbar(props) {

    const navigate = useNavigate();
    const [lingua, setLingua] = useState("ita")

    useEffect(()=>{
        props.setLang(lingua)
    }, [lingua])

    const chiudiTendina = () =>{
        setTimeout(()=>{
            document.getElementById("active").checked = false
        }, 200)
        
    }

    function vaiSezione(sezione){
        chiudiTendina()
        navigate('/')
        setTimeout(()=>{
            document.getElementById(sezione).scrollIntoView({behavior: "smooth", block: "center", inline: "center" })
        }, 300)
        
    }

    return (
        <div className='navbar_container'>
            <div className='navbar'>
                
                <img src={logo} className='logo_navbar' onClick={()=>{vaiSezione('home')}}/>

                <div className='rigth_navbar'>
                    
                    {/*<div className='lingua_navbar'>
                        <span className={lingua === "ita" ? "lingua_selezionata" : ""} onClick={()=>{setLingua("ita")}}>ITA</span>/
                        <span  className={lingua === "eng" ? "lingua_selezionata" : ""} onClick={()=>{setLingua("eng")}}>ENG</span>
    </div>*/}

                    <div className='menu_container'>
                        <input type="checkbox" id="active" />
                        <label htmlFor="active" className="menu-btn"><span></span></label>
                        <label htmlFor="active" className="close"></label>
                        <div className="wrapper">
                            <ul className='nav_links max-w'>
                                <li className='nav_elem'><a href="#" onClick={chiudiTendina} className='nav_link'>HOME</a></li>
                                <li className='nav_elem'><Link to="/manifesto" onClick={chiudiTendina} className='nav_link'>MANIFESTO</Link></li>
                                <li className='nav_elem'><Link to="/chisiamo" onClick={chiudiTendina} className='nav_link'>CHI SIAMO</Link></li>
                                <li className='nav_elem'><div onClick={()=>{vaiSezione('contatti')}} className='nav_link'>CONTATTI</div></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
